import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import companyFieldModel from "@app/util/fieldModel/CompanyFieldModel";
import { convertToPlatformFilterModel } from "@app/util/viewModel/convertToPlatformFilterModel";

// The $filters the companies list fetches with; the chat context sends the same object.
const buildCompanyListFilters = (
  filter: FilterModel,
  columns: ColumnModel
): PlatformFilterModel => ({
  includeAccessStatus: true,
  includeAssociations: true,
  includeEmailSubscriptionStatus: true,
  ...convertToPlatformFilterModel(filter, columns, companyFieldModel),
});

export default buildCompanyListFilters;
